import api from '../api';
import { BaseEntityModel } from '../baseEntityModel';


export interface CrfEsin204ViewModel extends BaseEntityModel {
    totalRegistroEsin204: number;
    processadoDescricao: any;
    id: string;
    fechamentoMinaProcessado: boolean;
    processado: boolean;
    dataInicio: Date;
    dataFim: Date;
    ano: number;
    mes: number;
    formData: any;
    ehContaResultado: boolean;
    processoandoExecutadoMesAno: boolean;
    descricaoProcessoExecutadoMesAno: string
}


export const getAllEsin204ContaResultado = () => {
    return api.get<Array<CrfEsin204ViewModel>>('crfEsin204/getAllEsin204ContaResultado');
}

export const getAllEsin204FechamentoMina = () => {
    return api.get<Array<CrfEsin204ViewModel>>('crfEsin204/getAllEsin204FechamentoMina');
}

export const importacaoPlanilhaCrfEsin204 = (values: CrfEsin204ViewModel, file: any) => {
    const form = new FormData();
    form.append('id', values.id);
    form.append('ehContaResultado', `${values.ehContaResultado}`);
    form.append('file', file);

    if (values.dataInicio)
        form.append('dataInicio', values.dataInicio.toString());

    if (values.dataFim)
        form.append('dataFim', values.dataFim.toString());

    return api.post<CrfEsin204ViewModel>(`crfEsin204`, form, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}